import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface MapStatusesButtonProps {
  onClick: () => void;
}

export const MapStatusesButton = ({ onClick }: MapStatusesButtonProps) => {
  const { t } = useTranslation('shipmentStatusMappingModule');

  return (
    <Button variant="primary" size="default" onClick={onClick} data-testid="open-interactive-mapping-button">
      {t('shipmentStatusMapping.interactiveMapping.button')}
    </Button>
  );
};
